import TitleBlockWrapper, {
  TitleDescription
} from '@anm/components/TitleBlock/Wrapper';
import styled from 'styled-components';

export const CardPlanWrapper = styled.div`
  border: 1px solid #ccdde6;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgb(1 83 130 / 10%);
  flex: 1;
  padding: 21px 30px 28px;
  display: flex;
  flex-direction: column;
  ${TitleBlockWrapper} {
    margin-bottom: 10px;
  }
  ${TitleDescription} {
    color: #919eaa;
    margin: 0;
    line-height: 25px;
  }
`;
